import { AddressComponent, ParsedAddress } from "../types/googlePlaces";

export function parseGoogleAddressComponents(
  addressComponents: AddressComponent[]
): ParsedAddress {
  let streetNumber = "";
  let route = "";
  let sublocality = "";
  let locality = "";
  let postalCode = "";
  let administrativeArea = "";
  let countryCode = "";

  for (const component of addressComponents) {
    const types = component.types;

    if (types.includes("street_number")) {
      streetNumber = component.longText;
    }
    if (types.includes("route")) {
      route = component.longText;
    }
    if (types.includes("sublocality") || types.includes("neighborhood") || types.includes("sublocality_level_1")) {
      sublocality = component.longText;
    }
    if (types.includes("locality")) {
      locality = component.longText;
    }
    if (types.includes("postal_code")) {
      postalCode = component.longText;
    }
    if (types.includes("administrative_area_level_1")) {
      administrativeArea = component.shortText;
    }
    if (types.includes("country")) {
      countryCode = component.shortText; // 2-letter ISO code (e.g., "NL", "US")
    }
  }

  return {
    line1: streetNumber ? `${route} ${streetNumber}`.trim() : route,
    line2: sublocality,
    zipCode: postalCode,
    city: locality,
    region: administrativeArea,
    countryCode: countryCode || undefined,
  };
}
